import {
  deserializeYesplanAPIDate,
  deserializeYesplanAPIDateAndTime,
  isOnSameDate,
  serializeYesplanAPIDate
} from '../libs/dateTimeUtilities';
import {
  printInShortFormatOrAsRelativeDate,
  printInHourDisplayFormat
} from '../libs/dateTimePrinting';

export default class YPEventScheduleObject {
  constructor(schedulesJSON) {
    const { defaultstartidx, defaultstopidx, entries } = schedulesJSON;
    const schedulesPerDate = {};
    entries.forEach((schedule, index) => {
      const scheduleObject = { ...schedule };
      const dateAndTimeObject = deserializeYesplanAPIDateAndTime(schedule.starttime);
      const dateString = serializeYesplanAPIDate(dateAndTimeObject);
      /* Set the isDefaultScheduleStart and isDefaultScheduleEnd on the schedule entries itself,
       * because the original index is lost by grouping them per date */
      if (defaultstartidx && index + 1 === defaultstartidx)
        scheduleObject.isDefaultScheduleStart = true;
      if (defaultstopidx && index + 1 === defaultstopidx)
        scheduleObject.isDefaultScheduleEnd = true;
      if (schedulesPerDate[dateString]) schedulesPerDate[dateString].push(scheduleObject);
      else schedulesPerDate[dateString] = [scheduleObject];
    });
    this.schedulesPerDate = schedulesPerDate;
  }

  getEntriesForDate(dateObject) {
    return this.schedulesPerDate[serializeYesplanAPIDate(dateObject)];
  }

  getSortedDates() {
    return Object.keys(this.schedulesPerDate)
      .map((dateString) => deserializeYesplanAPIDate(dateString))
      .sort((date1, date2) => date1.diff(date2));
  }

  isEmpty() {
    return Object.keys(this.schedulesPerDate).length === 0;
  }

  hasEntries() {
    return !this.isEmpty();
  }

  shouldDisplayDates(defaultDate) {
    return (
      Object.keys(this.schedulesPerDate).length !== 1 ||
      !isOnSameDate(
        defaultDate,
        deserializeYesplanAPIDate(Object.keys(this.schedulesPerDate)[0])
      )
    );
  }

  printDateForScheduleDayDivider(dateObject, dateFormatSetting) {
    return printInShortFormatOrAsRelativeDate(dateObject, dateFormatSetting, true, false);
  }

  printTimeForScheduleEntry(entry, timeFormatSetting) {
    return printInHourDisplayFormat(entry.starttime, timeFormatSetting);
  }
}
